import usePresentPage, {
  selectors as pageSelectors,
} from 'client/hooks/usePresentPage'
import { useManagement as useTypedManagement } from 'client/store/index'
import typedManagementSelectors from 'client/store/management/managementSelectors'
import { facebookConversionEvents } from 'common/constants/FacebookConversionEvents'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { GroupTitle } from 'src/editor/layout/sidebar/settings/group-title'
import { useAceEditor } from 'src/editor/shared/hooks/use-ace-editor'
import { SelectNew } from 'src/editor/shared/ui-lib/select-new/select-new'
import { Button } from '../../components'
import useUpdateTrackingProperty from '../../hooks/useUpdateTrackingProperty'

function Tracking() {
  const [isHeaderCode, setHeaderCode] = useState(false)
  const [isFooterCode, setFooterCode] = useState(false)
  const tracking = usePresentPage(pageSelectors.getTracking)
  const updateTrackingProperty = useUpdateTrackingProperty()
  const hasFacebookConversionPixel = useTypedManagement(
    typedManagementSelectors.hasFacebookConversionPixel,
  )
  const { t } = useTranslation()

  const isCodeDialogOpened = useTypedManagement(
    typedManagementSelectors.isCodeDialogOpened,
  )
  const { AceEditor, onOpenCodeEditor } = useAceEditor()

  useEffect(() => {
    if (!isCodeDialogOpened) {
      setHeaderCode(false)
      setFooterCode(false)
    }
  }, [isCodeDialogOpened])

  const openHeaderCodeEditor = async () => {
    setFooterCode(false)
    setHeaderCode(true)
    onOpenCodeEditor()
  }

  const openFooterCodeEditor = async () => {
    setHeaderCode(false)
    setFooterCode(true)
    onOpenCodeEditor()
  }

  function updateFbEvent(option) {
    if (!option) {
      return
    }

    return updateTrackingProperty('facebookConversionEvent')(option.value)
  }

  const facebookConversionEventsOptions = [
    {
      value: null,
      label: t('page_settings.tracking_code.default'),
    },
    {
      value: facebookConversionEvents.viewContent,
      label: t('page_settings.tracking_code.facebook_view_content_event'),
    },
    {
      value: facebookConversionEvents.purchase,
      label: t('page_settings.tracking_code.facebook_purchase_event'),
    },
    {
      value: facebookConversionEvents.lead,
      label: t('page_settings.tracking_code.facebook_lead_event'),
    },
    {
      value: facebookConversionEvents.schedule,
      label: t('page_settings.tracking_code.facebook_schedule_event'),
    },
  ]

  function getSelectedFacebookConversionEvent(event, t) {
    const selectedEvent = facebookConversionEventsOptions.find(
      option => option.value === event,
    )
    if (selectedEvent) {
      return selectedEvent
    }
    return facebookConversionEventsOptions[0]
  }

  return (
    <React.Fragment>
      <GroupTitle>page_settings.tracking.title</GroupTitle>
      {hasFacebookConversionPixel && (
        <SelectNew
          onChange={updateFbEvent}
          options={facebookConversionEventsOptions}
          labelText="page_settings.tracking_code.select_facebook_event.label"
          selectedOption={getSelectedFacebookConversionEvent(
            tracking.facebookConversionEvent,
          )}
          isMulti={false}
        />
      )}
      <Button
        small
        onClick={openHeaderCodeEditor}
        helpMessage="page_settings.header_code.help_message"
      >
        page_settings.header_code_edit.label
      </Button>
      {AceEditor && isHeaderCode && (
        <AceEditor
          label="page_settings.header_code_edit.label"
          value={tracking.headerCode}
          handleChange={updateTrackingProperty('headerCode')}
        />
      )}
      <Button
        onClick={openFooterCodeEditor}
        small
        helpMessage="page_settings.footer_code.help_message"
      >
        page_settings.footer_code_edit.label
      </Button>
      {AceEditor && isFooterCode && (
        <AceEditor
          label="page_settings.footer_code_edit.label"
          value={tracking.footerCode}
          handleChange={updateTrackingProperty('footerCode')}
        />
      )}
    </React.Fragment>
  )
}

export default Tracking
